import { render, staticRenderFns } from "./GroupPhase.vue?vue&type=template&id=bdb6d72e&scoped=true&"
import script from "./GroupPhase.vue?vue&type=script&lang=js&"
export * from "./GroupPhase.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bdb6d72e",
  null
  
)

export default component.exports